import '@/styles/directives/ripple.scss';

export default {
    bind(el) {
        el.addEventListener('click', function(event) {
            initRipple(event);
        });

        el.addEventListener('init-ripple', function(event) {
            initRipple(event);
        });

        function initRipple(event) {
            let _this = el,
                offset = _this.getBoundingClientRect(),
                positionX = (event.pageX - offset.left),
                positionY = (event.pageY - offset.top),
                rippleElement = document.createElement('div'),
                circleElement;
            rippleElement.classList.add('ripple-effect-vue', 'c-ripple-vue', 'is-active-vue');
            rippleElement.innerHTML = '<span class="c-ripple-circle-vue"></span>';
            _this.appendChild(rippleElement);
            circleElement = rippleElement.querySelector('.c-ripple-circle-vue');
            circleElement.style.left = `${positionX}px`;
            circleElement.style.top = `${positionY}px`;
            setTimeout(() => {
                circleElement.style.opacity = 0;
                setTimeout(() => {
                    rippleElement.remove();
                }, 500);
            }, 0);
        }
    }
};